import Repository from './Repository'

const action = 'organization-stevedores'

export default {
  getList(settings = {}) {
    let params = ''

    for (let key in settings) {
      params += params ? '&' : '?'
      params += `${key}=${settings[key]}`
    }

    return Repository.get(action + params)
  },
  postItem(data) {
    return Repository.post(action, data)
  },
  updateItem(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
